import VIDABOO_CONSTANTS from '../../config/consts';
import httpService from './httpService';
const service = {};
service.paths = VIDABOO_CONSTANTS.REST_PATHS;
const getEndpointPath = (
  basePath,
  {
    endpoint,
    endpointParam,
    endpoint2,
    endpointParam2,
    endpoint3,
    endpointParam3,
  },
) => {
  let pathStr = basePath + (endpoint ? endpoint : '');
  pathStr = pathStr + (endpointParam ? '/' + endpointParam : '');
  pathStr = pathStr + (endpoint2 ? '/' + endpoint2 : '');
  pathStr = pathStr + (endpointParam2 ? '/' + endpointParam2 : '');
  pathStr = pathStr + (endpoint3 ? '/' + endpoint3 : '');
  pathStr = pathStr + (endpointParam3 ? '/' + endpointParam3 : '');
  if (endpoint || endpointParam) pathStr += '/';
  return pathStr;
};
const serializeParams = (params) => {
  const parts = [];

  for (let [key, value] of Object.entries(params)) {
    if (Array.isArray(value)) {
      for (let item of value) {
        // parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
        if (item) {
          parts.push(`${key}=${item}`);
        }
      }
    } else {
      if (key && value !== null) {
        parts.push(`${key}=${value}`);
      }
    }
  }

  return parts.join('&');
};

const genericRestRequest = (
  type,
  endpointUrl,
  postData,
  successCallbackFunction,
  failureCallbackFunction,
  queryParams,
) => {
  switch (type) {
    case 'get':
      httpService
        .get(endpointUrl, {
          params: postData,
          paramsSerializer: serializeParams,
        })
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            if (typeof successCallbackFunction === 'function') {
              successCallbackFunction(response.data);
            }
          } else {
            failureCallbackFunction(response.data);
          }
        })
        .catch((error) => {
          failureCallbackFunction(error);
        });
      break;
    case 'save':
      httpService
        .post(endpointUrl, postData, {
          params: queryParams,
        })
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            if (typeof successCallbackFunction === 'function') {
              successCallbackFunction(response.data);
            }
          } else {
            failureCallbackFunction(response.data);
          }
        })
        .catch((response) => {
          failureCallbackFunction(response);
        });
      break;
    case 'update':
      httpService
        .put(endpointUrl, postData)
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            if (typeof successCallbackFunction === 'function') {
              successCallbackFunction(response.data);
            }
          } else {
            failureCallbackFunction(response.data);
          }
        })
        .catch((response) => {
          failureCallbackFunction(response);
        });
      break;
    case 'delete':
      httpService
        .delete(endpointUrl, {
          params: postData,
        })
        .then((response) => {
          if (response.status >= 200 && response.status < 300) {
            if (typeof successCallbackFunction === 'function') {
              successCallbackFunction(response.data);
            }
          } else {
            failureCallbackFunction(response.data);
          }
        })
        .catch((response) => {
          failureCallbackFunction(response);
        });
      break;
    default:
  }
};

export const newGenericRestRequest = async (
  type,
  endpointUrl,
  postData,
  config = {},
) => {
  let response;
  try {
    switch (type) {
      case 'get':
        response = await httpService.get(endpointUrl, {
          params: postData,
          paramsSerializer: serializeParams,
        });
        break;
      case 'save':
        response = await httpService.post(endpointUrl, postData, config);
        break;
      case 'put':
        response = await httpService.put(endpointUrl, postData, config);
        break;
      case 'delete':
        response = await httpService.delete(endpointUrl, {
          data: postData,
          params: postData,
        });
        break;
      default:
        console.debug('ERROR 301: not a valid HTTP Type. ');
    }
  } catch (response) {
    console.debug(response);
    return response;
  }
  return response;
};

const genericRestService = (restPath) => {
  const genericRestServiceObj = {
    save: async (params, postData) => {
      return await newGenericRestRequest(
        'save',
        getEndpointPath(restPath, params),
        postData,
      );
    },
    get: async (params, postData) => {
      return await newGenericRestRequest(
        'get',
        getEndpointPath(restPath, params),
        postData,
      );
    },
    update: async (params, postData) => {
      return await newGenericRestRequest(
        'put',
        getEndpointPath(restPath, params),
        postData,
      );
    },
    delete: async (params, postData) => {
      return await newGenericRestRequest(
        'delete',
        getEndpointPath(restPath, params),
        postData,
      );
    },
  };
  return genericRestServiceObj;
};

export const AuthRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.AUTH, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.AUTH, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.AUTH, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'put',
      getEndpointPath(service.paths.AUTH, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const UserRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.USER, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.USER, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.USER, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'put',
      getEndpointPath(service.paths.USER, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const MentorRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.MENTOR, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.MENTOR, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.MENTOR, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'put',
      getEndpointPath(service.paths.MENTOR, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const AccountRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.ACCOUNT, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.ACCOUNT, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.ACCOUNT, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'put',
      getEndpointPath(service.paths.ACCOUNT, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};
export const WidgetRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.WIDGET, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.WIDGET, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.WIDGET, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'delete',
      getEndpointPath(service.paths.WIDGET, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const FileHandlerRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.PHOTOS, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.PHOTOS, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.PHOTOS, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'put',
      getEndpointPath(service.paths.PHOTOS, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const AnalyticsEventRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.ANALYTICS_EVENTS, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.ANALYTICS_EVENTS, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const SessionTemplateRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.SESSION_TEMPLATE, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.SESSION_TEMPLATE, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.SESSION_TEMPLATE, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'put',
      getEndpointPath(service.paths.SESSION_TEMPLATE, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};
export const SessionInstanceRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.SESSION_INSTANCE, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.SESSION_INSTANCE, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.SESSION_INSTANCE, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'put',
      getEndpointPath(service.paths.SESSION_INSTANCE, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const ChatRoomRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.CHAT_ROOM, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.CHAT_ROOM, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.CHAT_ROOM, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'delete',
      getEndpointPath(service.paths.CHAT_ROOM, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const ChatMessageRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.CHAT_MESSAGE, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.CHAT_MESSAGE, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'delete',
      getEndpointPath(service.paths.CHAT_MESSAGE, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const EmailDigestRestService = {
  put: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.USER, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

// export const TokboxRestService = {
//   get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
//     genericRestRequest(
//       'get',
//       getEndpointPath(service.paths.TOKBOX, params),
//       params,
//       successCallbackFunction,
//       failureCallbackFunction,
//     );
//   },
// };
export const TokboxRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.TOKBOX,
);

export const SmsMessageRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.SMS_MESSAGES, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.SMS_MESSAGES, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const PaymentRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.PAYMENT, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.PAYMENT, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.PAYMENT, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const AgencyCustomerBillingRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.AGENCY_CUSTOMER_BILLING, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.AGENCY_CUSTOMER_BILLING, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.AGENCY_CUSTOMER_BILLING, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const BillingPlanServiceNew = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.BILLING_PLANS,
);

export const SubscriptionTransactionsService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.SUBSCRIPTION_TRANSACTIONS,
);

export const NextPaymentService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.NEXT_PAYMENT,
);

export const BillingPlanEventService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.BILLING_PLAN_EVENTS, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.BILLING_PLAN_EVENTS, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const BillingPlanService = {
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.BILLING_PLANS, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const AiCreditBalanceRestService = {
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.AI_CREDITS_BALANCE, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.AI_CREDITS_BALANCE, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const BookingFlowInstanceRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.BOOKING_FLOW_INSTNACE, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  get: (params, postData, successCallbackFunction, failureCallbackFunction) => {
    genericRestRequest(
      'get',
      getEndpointPath(service.paths.BOOKING_FLOW_INSTNACE, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  update: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'update',
      getEndpointPath(service.paths.BOOKING_FLOW_INSTNACE, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
  delete: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
  ) => {
    genericRestRequest(
      'delete',
      getEndpointPath(service.paths.BOOKING_FLOW_INSTNACE, params),
      params,
      successCallbackFunction,
      failureCallbackFunction,
    );
  },
};

export const RedeemGiftRestService = {
  save: (
    params,
    postData,
    successCallbackFunction,
    failureCallbackFunction,
    queryParams,
  ) => {
    genericRestRequest(
      'save',
      getEndpointPath(service.paths.REDEEM_GIFT, params),
      postData,
      successCallbackFunction,
      failureCallbackFunction,
      queryParams,
    );
  },
};

export const AffiliateInfoRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.AFFILIATE_INFO,
);
export const AffiliateConnectionsRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.AFFILIATE_CONNECTIONS,
);

export const MediaRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.AUDIO_MESSAGES,
);

export const FileSharingRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.FILE_MESSAGES,
);
export const ThreeDRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.THREED,
);
// export const ThreeDRestThumbnailService = genericRestService(
//   VIDABOO_CONSTANTS.REST_PATHS.THUMBNAIL,
// );
export const ThreeDFILEIDRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.ObjectType,
);

export const VersionRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.APP_VERSION,
);

export const PushNotificationsRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.PUSH_NOTIFICATIONS,
);

export const ImageSharingRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.IMAGE_MESSAGES,
);

export const ZapierIntegrationRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.ZAPIER,
);
export const WebhookIntegrationRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.WEBHOOK,
);

export const WhiteLabelingRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.WHITE_LABEL,
);

export const ControlledService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.CONTROLLED,
);
export const ImpersonationService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.IMPERSONATION,
);
export const MarketingParametersService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.MARKETING,
);
export const CallRecordingService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.CALL_RECORDING,
);
export const PublicMediaLinkService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.PUBLIC_MEDIA_LINK,
);

export const CalendarService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.CALENDAR,
);

export const GoogleEmailAuthRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.GOOGLE_EMAIL,
);

export const MessageBrokerRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.MESSAGE_BROKER,
);

export const DynamicFormRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.DYNAMIC_FORM,
);

export const DynamicInstanceRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.DYNAMIC_INSTANCE,
);

export const NotifyCustomerRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.NOTIFY_CUSTOMER,
);

export const SmtpIntegrationService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.SMTP_INTEGRATION,
);

export const MeetingRoomRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.MEETING_ROOM,
);
export const StripeC2CRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.STRIPE_C2C,
);
export const C2CMoneyTransactionRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.C2C_MONEY_TRANSACTION_EVENT,
);
export const CCLinkageRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.CC_LINKAGE,
);
export const CnameRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.CNAME_INSTANCE,
);
export const KBResourceRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.KB_RESOURCES,
);
export const BrainRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.BRAIN,
);
export const TrainingRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.TRAINING,
);
export const EmailCustomizationRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.EMAIL_CUSTOMIZATION,
);
export const AiCompletionRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.AI_COMPLETION,
);
export const ChatHandoffFlowRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.CHAT_HANDOFF_FLOW,
);
export const AgentHandoffFlowRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.AGENT_HANDOFF_FLOW,
);
export const ResellerAgencyRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.RESELLER_AGENCY,
);
export const AgencyCustomerRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.AGENCY_CUSTOMER,
);
export const AgencyMemberRestService = genericRestService(
  VIDABOO_CONSTANTS.REST_PATHS.AGENCY_MEMBER,
);

const restServices = {...service};
export default restServices;
